import request from '@/utils/request';export const listInquiries=params=>request({url:'/dkmall/inquiries',method:'get',params});export const getInquiry=(id,source)=>request({url:`/dkmall/inquiries/${id}`,method:'get',params:{source}})
